import React, { useRef } from "react";
import { useGlobalContext } from "../context";
import CocktailList from "../components/CocktailList";
import Header from "../components/Header";

const Search = () => {
  const animation = useRef();

  const { setSearchTerm } = useGlobalContext();
  const searchValue = React.useRef("");

  function searchCocktail() {
    setSearchTerm(searchValue.current.value);
  }

  return (
    <div className="search-landing-page">
      <Header text="SEARCH" />
      <div className="search-bar">
        <div className="search-bar-container">
          <input
            type="text"
            name="name"
            id="name"
            ref={searchValue}
            onChange={searchCocktail}
            className="searchInput"
            placeholder="So what's on your mind ?"
          />
        </div>
      </div>
      <CocktailList />
    </div>
  );
};

export default Search;
